const doc = [({"ko":({"adminConstantHotelCheckInStatus":({"rejected":"거부", "requested":"요청됨"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;